var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 98,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M24.2642 88.6437s-.004-65.04 0-72.368c.005-8.588 7.317-15.455 15.966-15.455s15.692 6.873 15.966 15.455v.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.3179 91.4767l-.01 5.402 71.878-.007.01-5.391c.001-1.566-1.268-2.837-2.835-2.837H3.1519c-1.564 0-2.833 1.268-2.834 2.833"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 0.6,
    d: "M.3179 91.4767l-.01 5.402 71.878-.007.01-5.391c.001-1.566-1.268-2.837-2.835-2.837H3.1519c-1.564 0-2.833 1.268-2.834 2.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M78.2505 38.4328l-.001-18.779c0-1.566-1.27-2.835-2.836-2.834l-38.309.008c-1.566 0-2.834 1.269-2.834 2.834v16.442c0 .004-.001.007-.001.011l.002 12.294c0 .47.381.85.851.85l42.278-.009c.47 0 .85-.38.85-.85l-.001-9.952c0-.005.001-.01.001-.015"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M78.2505 38.4328l-.001-18.779c0-1.566-1.27-2.835-2.836-2.834l-38.309.008c-1.566 0-2.834 1.269-2.834 2.834v16.442c0 .004-.001.007-.001.011l.002 12.294c0 .47.381.85.851.85l42.278-.009c.47 0 .85-.38.85-.85l-.001-9.952c0-.005.001-.01.001-.015zm-21.9883 15.959v12.75m-9.6479-12.75l-9.017 9.015m28.3124-9.015l9.018 9.015"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.9d948ea83fe6245b7c28a42c6eb71c81.svg";
export { ForwardRef as ReactComponent };